import { NAME } from './constants';

export default {
  BATCH_SALES_ORDERS: `${NAME}/BATCH_SALES_ORDERS`,
  BATCHED_SALES_ORDERS: `${NAME}/BATCHED_SALES_ORDERS`,
  BATCHED_SUCCESSFULLY: `${NAME}/BATCHED_SUCCESSFULLY`,
};
